import "../../theme/index.less";
import React, { FC } from "react";
import classNames from "classnames";
import { useDarkMode, RemoPrefersColorScheme } from "./useDarkMode";
import { useIsomorphicLayoutEffect } from "react-use";

export * from "./useDarkMode";

export const DarkModeContext = /* @__PURE__ */ React.createContext(false);

export interface RemoThemeProviderProps
    extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    prefersColorScheme?: RemoPrefersColorScheme;
}

export const RemoThemeProvider: FC<RemoThemeProviderProps> = ({
    prefersColorScheme = "light",
    className,
    ...restProps
}) => {
    const darkMode = useDarkMode(prefersColorScheme);
    return (
        <DarkModeContext.Provider value={darkMode}>
            <div
                {...restProps}
                className={classNames(
                    "remo-theme-root",
                    { "remo-color-scheme-dark": darkMode },
                    className,
                )}
            />
        </DarkModeContext.Provider>
    );
};

export interface RemoThemeBodyProviderProps {
    prefersColorScheme?: RemoPrefersColorScheme;
    children?: React.ReactNode;
}

// 默认为dark模式
export const RemoThemeBodyProvider: FC<RemoThemeBodyProviderProps> = ({
    prefersColorScheme = "dark",
    children,
}) => {
    const darkMode = useDarkMode(prefersColorScheme);
    useIsomorphicLayoutEffect(() => {
        document.body.classList.add("remo-theme-root");
        document.body.classList.toggle("remo-color-scheme-dark", darkMode);
    }, [darkMode]);
    return <DarkModeContext.Provider value={darkMode}>{children}</DarkModeContext.Provider>;
};
